import React, { cloneElement, useState, useEffect} from "react";
import { Scrollbars } from "react-custom-scrollbars";
import {
  List,
  downloadCSV,
  Pagination,
  Datagrid,
  DateField,
  ReferenceField,
  TextField,
  BooleanField,
  EditButton,
  ShowButton,
  Filter,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  SelectInput,
  TopToolbar,
  RefreshButton,
  ExportButton,
  usePermissions,
  useResourceContext,
  useRecordContext,
  useTranslate,
  DateTimeInput,
  SelectArrayInput,
  CreateButton,
  DateInput
} from "react-admin";
import {
  getDigitalOrderStatusChoices,
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { OrderStatus } from "./common";
import moment from "moment";
// import { DateTimeInput } from "react-admin-date-inputs";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const selectInputStyle = {
  width: 200,
};

const LoyaltyRewardFilter = ({ permissions, ...props }) => {
  const translate = useTranslate();
    const localStorageAppType = getLocalStorageKey("app_type");
    const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");
  
    useEffect(() => {
      if (localStorageAppType === "HOLCIM") {
        setBaseThemeColor("holcimtheme");
      } else {
        setBaseThemeColor("clickittheme");
      }
    }, [localStorageAppType]);
    
  return (
    <Filter {...props}>
      <ReferenceInput
        label={translate(baseThemeColor === 'clickittheme'? "resources.user_loyalty_points.fields.clickit_user" : "resources.user_loyalty_points.fields.holcim_user")}
        source="user_id"
        reference="users"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="first_name" />
      </ReferenceInput>
      <TextInput source="category" defaultValue="" />
      <TextInput source="comments" defaultValue="" />
      <SelectInput source="points_action" label="Select Action" choices={[
          { id: 'add', name: 'Add' },
          { id: 'redeem', name: 'Redeem' },
        ]}
      />
      <DateInput
        source="created_at_from"
        label="Created At From Date"
        maxDate={new Date()}
      />
      <DateInput
        source="created_at_to"
        label="Created At To Date"
        maxDate={new Date()}
      />

    </Filter>
  );
};

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(location.search);

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    // console.log('callExport...e', e);
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data[0].result);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          const res = jsonD.data[0].result;
          const f_date = moment(jsonD.data[0].f_date).format("MM/DD/YYYY");
          const t_date = moment(jsonD.data[0].t_date).format("MM/DD/YYYY");
          // console.log('f_date= inside callback', moment(f_date).format('MM/DD/YYYY'));
          Swal.fire({
            html:
              res && msg
                ? msg + "&nbsp" + f_date + "&nbspto&nbsp" + t_date
                : msg,
            icon: res ? "success" : "info",
            width: 640,
          });
          // this.setState({ modalShow: true });
          // this.setState({ modalMsg: msg });
        });
    } else {
      setCustomFilterUrl(location.search);
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          const res = jsonD.data[0].result;
          const f_date = moment(jsonD.data[0].f_date).format("MM/DD/YYYY");
          const t_date = moment(jsonD.data[0].t_date).format("MM/DD/YYYY");
          Swal.fire({
            html:
              res && msg
                ? msg + "&nbsp" + f_date + "&nbspto&nbsp" + t_date
                : msg,
            icon: res ? "success" : "info",
            width: 640,
          });
          // this.setState({ modalShow: true });
          // this.setState({ modalMsg: msg });
        });
    }
  };
  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        <CreateButton/>
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </>
  );
};


const LoyaltyRewardPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);


const LoyaltyList = (props) => {
  // const { state, props, permissions } = this;
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];
  const { permissions } = usePermissions();
  const translate = useTranslate();

   const localStorageAppType = getLocalStorageKey("app_type");
   const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");
  
    useEffect(() => {
      if (localStorageAppType === "HOLCIM") {
        setBaseThemeColor("holcimtheme");
      } else {
        setBaseThemeColor("clickittheme");
      }
    }, [localStorageAppType]);
  


  return (
    <>
      <Scrollbars className="scroll-container">
        <List
          title={translate(
            "resources.user_loyalty_points.fields.loyalty_points"
          )}
          source="sap_order_failed_message"
          pagination={<LoyaltyRewardPagination />}
          sort={{ field: "created_at", order: "DESC" }}
          actions={<ListActions />}
          // exporter={exporter}
          {...props}
          filters={<LoyaltyRewardFilter permissions={props} />}
          // bulkActionButtons={false}
        >
          <Datagrid
            rowClick={false}
            bulkActionButtons={false}
            className="order-list-white-space"
          >
             <ReferenceField
                label={translate(baseThemeColor === 'clickittheme'? "resources.user_loyalty_points.fields.clickit_user" : "resources.user_loyalty_points.fields.holcim_user")}
                source="user_id"
                reference="users"
                link="show"
                allowEmpty
            >
                <TextField source="first_name" />
            </ReferenceField>
            <ReferenceField
                label="Admin Panel User"
                source="admin_panel_user_id"
                reference="whitelist_users"
                link="show"
                allowEmpty
            >
                <TextField source="username" />
            </ReferenceField>
            <OrderStatus source="points" />
            <TextField source="category" />
            <TextField source="comments" className="loyalty-comment" />
            {/* <DateField source="expired_at" /> */}
            <DateField source="created_at" showTime />
            {/* <DateField source="updated_at" /> */}
            <EditButton />
            {/* <ShowButton /> */}
          </Datagrid>
        </List>
      </Scrollbars>
    </>
  );
};

export default LoyaltyList;
